import { Trans } from 'react-i18next';
import type { NetworkDeviceSignals__DeviceSignal as DeviceSignal } from '../queries/list.generated';
import { actionTargetName, humanizeAction } from './utils';

export const cancelPrompt = (signal: DeviceSignal) => {
  const { action, name: signalName, deviceCount } = signal;

  return (
    <Trans
      i18nKey="pages.device_signals.list.dialogs.cancel.prompt_detailed_plural"
      count={deviceCount}
      values={{
        signalName,
        actionTarget: actionTargetName(action),
        count: deviceCount,
      }}
      components={{ strong: <strong /> }}
    />
  );
};

export const runPrompt = (signal: DeviceSignal) => {
  const { action, name: signalName, deviceCount } = signal;
  const entityName = actionTargetName(action);

  let translationKey: string;
  const values: Record<string, string | number> = {
    signalName,
    count: deviceCount,
  };

  switch (action.__typename) {
    case 'SignalActionPlayOverlay':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_play_overlay_plural';
      values.entityName = entityName;
      break;
    case 'SignalActionPlayShow':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_play_show_plural';
      values.entityName = entityName;
      break;
    case 'SignalActionReboot':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_reboot_plural';
      break;
    case 'SignalActionStopOverlay':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_stop_overlay_plural';
      break;
    case 'SignalActionTriggerView':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_play_view_plural';
      values.entityName = entityName;
      break;
    case 'SignalActionTuneChannel':
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_tune_channel_plural';
      values.entityName = entityName;
      break;
    default:
      translationKey = 'pages.device_signals.list.dialogs.run.prompt_execute_action_plural';
      values.actionName = humanizeAction(action);
  }

  return (
    <Trans
      i18nKey={translationKey}
      count={deviceCount}
      values={values}
      components={{ strong: <strong /> }}
    />
  );
};
